const routes = {
  home: "/",
  banner: "/section-banner",
}

export default routes
